import { http } from 'services';

export const All = () =>
http.request.get('/v1/gov-function/reference/basis-types');

export const List = ({ params }) =>
http.request.post('/v1/gov-function/basis-type/pageable', {
  per_page: params.perPage,
  page: params.page,
  sort: params.sort,
  search: params.filter
});

export const Single = ({ id }) =>
http.request.get(`/v1/gov-function/basis-type/${id}`);
